

const EmailIcon1 = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M24.001 31.499C28.1431 31.499 31.501 28.1412 31.501 23.999C31.501 19.8569 28.1431 16.499 24.001 16.499C19.8588 16.499 16.501 19.8569 16.501 23.999C16.501 28.1412 19.8588 31.499 24.001 31.499Z"
                stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M33.9529 38.9994C30.6112 41.2172 26.6245 42.2556 22.6255 41.9496C18.6264 41.6437 14.8441 40.011 11.8786 37.3107C8.91311 34.6104 6.93433 30.997 6.25624 27.0441C5.57815 23.0911 6.23959 19.0248 8.13561 15.4906C10.0316 11.9563 13.0536 9.15645 16.7221 7.53524C20.3905 5.91403 24.4953 5.56434 28.3852 6.54166C32.275 7.51898 35.727 9.76732 38.1936 12.9299C40.6601 16.0926 41.9998 19.9883 42.0001 23.999C42.0001 28.1412 40.5001 31.499 36.7501 31.499C33.0001 31.499 31.5001 28.1412 31.5001 23.999V16.499"
                stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default EmailIcon1